export default "__VITE_ASSET__DYx3AO0X__"